import { render, staticRenderFns } from "./WorkflowStateThresholdDetail.vue?vue&type=template&id=e58763e4&"
import script from "./WorkflowStateThresholdDetail.vue?vue&type=script&lang=ts&"
export * from "./WorkflowStateThresholdDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports